export default "__VITE_ASSET__jdLpA822__"